
import React from "react"

import { LANGUAGES } from "../data/config/constants"

export const LangContext = React.createContext(LANGUAGES.ENGLISH)
